import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated } from '../helpers/userHelper';

const UserRoute = ({ user, ...props }) => {
  if (isAuthenticated(user)) {
    return <Route {...props} />;
  } else {
    return <Redirect to="/login" />;
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
  };
};

export default connect(mapStateToProps)(UserRoute);
